"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _ScopeContext = require("../../context/ScopeContext");
var _layout = require("../../layout");
var _text = require("../../text");
var _utils = require("../../utils");
var _BoxContainer = _interopRequireDefault(require("./BoxContainer"));
var _helperComponents = require("./helperComponents");
var _react2 = require("@emotion/react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DetailedBox = _ref => {
  let {
    children,
    details,
    isInverted: isInvertedColorScheme,
    renderTitle = _helperComponents.defaultTitleRenderer,
    titleText,
    ...boxContainerProps
  } = _ref;
  const scopeId = (0, _react.useContext)(_ScopeContext.ScopeContext);
  const hasTitle = !!titleText;
  const hasDetails = !!details;
  const renderDetails = () => typeof details === 'string' ? (0, _react2.jsx)(_text.Text, {
    variant: _text.TextVariant.BodySM
  }, details) : (0, _react2.jsx)(_layout.View, null, details);
  return (0, _react2.jsx)(_BoxContainer.default, (0, _extends2.default)({}, (0, _utils.getScopedThemeProps)({
    isInvertedColorScheme,
    scopeId
  }), boxContainerProps), (0, _react2.jsx)(_layout.Row, {
    gridGap: "S100",
    justifyContent: "space-between",
    maxWidth: "100%"
  }, hasTitle ? renderTitle({
    titleText
  }) : hasDetails && renderDetails(), children), hasDetails && hasTitle && renderDetails());
};
DetailedBox.displayName = 'DetailedBox';
var _default = exports.default = DetailedBox;